module.exports = __webpack_public_path__ + "img/qqc_logo@3x.e5b65197.png";